import ReactDOM from 'react-dom';
import React from 'react';

import MapDemo from './map-demo';

ReactDOM.render(<MapDemo />, document.getElementById('root'));
